import styled, { css } from 'styled-components';

interface propsImage {
  $style: string | undefined
}

const style = (props: string) => css`
  ${props}
  .pswp__default-caption{
    color: ${({ theme }) => theme.colors.grayscale[50]};
    ${({ theme }) => theme.typography.font};
    display: block;
  }
`;

export const ImageStyle = styled.img<propsImage>`
  ${(props) => (props.$style ? style(props.$style) : '')}
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
`;

export const Subtitle = styled.small`
  color: ${({ theme }) => theme.colors.grayscale[50]};
  ${({ theme }) => theme.typography.subtitle};
  display: block;
  margin-bottom: .5em !important;
`;

export const Credit = styled.small`
  color: ${({ theme }) => theme.colors.grayscale[50]};
  ${({ theme }) => theme.typography.font};
  display: block;
`;
